<div class="basic-card" (click)="onEditPersonalityClick()">
  <nz-tag class="fit-content" [nzBordered]="false" [nzColor]="personality?.unsafeSubData?.color">{{
    personality?.title
  }}</nz-tag>

  <div class="edit-button">
    <button nz-button nzType="primary" nzSize="small" (click)="onEditPersonalityClick()">
      <span nz-icon style="font-size: 16px" class="material-symbols-rounded">edit</span>
      Edit
    </button>
  </div>
</div>

<app-new-edit-personality
  [(isNewEditVisible)]="isNewEditVisible"
  [selectedItem]="personality"
></app-new-edit-personality>
